import * as React from "react";
import { BannerContainer } from "../../Components/BannerContainer";
import { NameView } from "../../Components/NameView";
import { PriceView, PriceUIType } from "../../Components/PriceView";
import { StarAndSold } from "../../Components/StarAndSold";
import { TwentyFour } from "../../Components/TwentyFour";
import { DoubleCardWrap, Desc } from "./styled";
import { getInitProduct } from "../utils";
import { returnProductId } from "../../../../../../utils/browser";
const DoubleCard = (props) => {
    const { imgWidth, imgHeight, placeholderBg, poolId, onClick } = props;
    const { img, name, price, originPrice, url, ltImg, rtImg, sold, star, titleImg, twentyTour, countdownToEnd, } = getInitProduct(props.product);
    const idProps = returnProductId(poolId, props.product.gpid);
    return (React.createElement(DoubleCardWrap, Object.assign({ imgWidth: imgWidth, href: url, onClick: onClick }, idProps),
        React.createElement(BannerContainer, { imgWidth: imgWidth, imgHeight: imgHeight, placeholderBg: placeholderBg, banner: img, ltImg: ltImg, rtImg: rtImg, countdownToEnd: countdownToEnd }),
        React.createElement(Desc, null,
            React.createElement(NameView, { name: name, activeImg: titleImg }),
            React.createElement(PriceView, { price: price, originPrice: originPrice, type: PriceUIType.Large }),
            star ? React.createElement(StarAndSold, { star: star, sold: sold }) : null,
            twentyTour && React.createElement(TwentyFour, { text: twentyTour }))));
};
export default DoubleCard;
